import React, { useEffect, useState } from 'react';
import { FormConfig } from '../../../components/Fields/Types';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton from '../../../components/Buttons/SaveButton';
import ButtonBar from '../../../components/Fields/ButtonBar';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import { Result, DataResult } from '../../../types/Result';
import ItemRevisionUserDefinedFieldsModel from '../../../models/ItemRevisionUserDefinedFieldsModel';
import UserDefinedFieldValueModel from '../../../models/UserDefinedFieldValueModel';
import UserDefinedField from '../../../components/Fields/UserDefinedField';
import UserDefinedFieldCategoryValueModel from '../../../models/UserDefinedFieldCategoryValueModel';

export interface IProps {
    itemId: number
    itemRevisionId: number
    itemTypeId: number
    refreshNr: number
}

const ItemRevision_tab_UserDefinedFields: React.FC<IProps> = ({ itemId, itemRevisionId, itemTypeId, refreshNr }) => {
    const [formData, setFormData] = useState<ItemRevisionUserDefinedFieldsModel>();
    const [serverErrors, setServerErrors] = useState<DataResult<ItemRevisionUserDefinedFieldsModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getFormData();
    }, [itemRevisionId, refreshNr]);

    function getFormData() {
        DataService.get<ItemRevisionUserDefinedFieldsModel>('api/v1/ItemRevisionUserDefinedFields/ByItemRevision/' + itemRevisionId)
            .then(response => {
                setFormData(response);
            })
            .catch(e => { handleException(e); });
    }

    function submit() {
        if (formData) {
            DataService
                .put<DataResult<ItemRevisionUserDefinedFieldsModel>>(`api/v1/ItemRevisionUserDefinedFields/UpdateCollection`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        if (formData) {
            name.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setFormData(formData);
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, formData);
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    if (formData && formData.userDefinedFieldCategories) {
        formData.userDefinedFieldCategories.forEach((category, categoryIndex) => {
            if (category.userDefinedFieldValues) {
                category.userDefinedFieldValues.forEach((udf, udfIndex) => {
                    if (udf.userDefinedField.required) {
                        formConfig.fields.push({
                            name: `userDefinedFieldCategories.${categoryIndex}.userDefinedFieldValues.${udfIndex}.value`,
                            label: udf.userDefinedField.name,
                            labelSize: 4,
                            validationRules: [{ type: 'isRequired' }]
                        });
                    } else {
                        formConfig.fields.push({
                            name: `userDefinedFieldCategories.${categoryIndex}.userDefinedFieldValues.${udfIndex}.value`,
                            label: udf.userDefinedField.name,
                            labelSize: 4,
                        });
                    }
                })
            }
        });
    }

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!formData || !formData.userDefinedFieldCategories)
        return null;

    var fields = formData.userDefinedFieldCategories.map((category: UserDefinedFieldCategoryValueModel, categoryIndex: number) => {
        let udfFields: JSX.Element[] = []
        if (category.userDefinedFieldValues) {
            udfFields = category.userDefinedFieldValues.map((udf: UserDefinedFieldValueModel, udfIndex: number) => {
                return <UserDefinedField
                    {...getFieldProps(`userDefinedFieldCategories.${categoryIndex}.userDefinedFieldValues.${udfIndex}.value`)}
                    userDefinedFieldValue={udf}
                    visible={udf.userDefinedField.visibleEdit}
                    key={`${categoryIndex}${udfIndex}`}
                />
            })
        }
        return (
            <div className='col-md-4' style={{ display: 'inline-block', verticalAlign: 'top' }} key={categoryIndex}>
                <h2>{category.name}</h2>
                <div>
                    {udfFields}
                </div>
            </div>
            )
    });

    //console.log(formConfig)
    //console.log(fields)

    return (
        <div style={{ flexDirection: "row", marginTop: -15 }}>
            <ButtonBar offset={2}>
                <Authorize applicationFunction={ApplicationFunctions.UpdateItemRevision} itemTypeId={itemTypeId}>
                    <SaveButton  {...getSubmitButtonProps()} />
                </Authorize>
            </ButtonBar>
            {fields}
            <ButtonBar offset={2}>
                <Authorize applicationFunction={ApplicationFunctions.UpdateItemRevision} itemTypeId={itemTypeId}>
                    <SaveButton  {...getSubmitButtonProps()} />
                </Authorize>
            </ButtonBar>
        </div>
    );
}
export default ItemRevision_tab_UserDefinedFields;